import request from '@/utils/request'

/**
 * 获取系统标签树
 */
export function findSystemLabel(labelId) {
    return request({
        url: `/api/label/${labelId}`,
        method: 'get'
    })
}

/**
 * 获取叶子节点标签
 */
export function findLeafLabel(labelId) {
    return request({
        url: `/api/label/leaf/${labelId}`,
        method: 'get'
    })
}



